
import {inject, Injectable} from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects"
import { catchError, map, tap, mergeMap, take } from 'rxjs/operators';
import { CrudService } from '../../services/crud/crud.service';
import { Observable, of } from "rxjs";
import { CrudFailedAction, CrudsActionType } from '../actions/crud.action';
import { NavController } from '@ionic/angular';
import { Store } from "@ngrx/store";
import { State } from "../states/state.model";
import { loadDataActionType } from "../actions/load-data.action";





@Injectable()
export class CrudEffect{

    type:string="";
    typeReload:string="";
    data:any;
    initial:boolean=true;
    typeStatus:string="";
    server:number=0;
    constructor(private store:Store<State> ,private actions$:Actions,private crud:CrudService,private navCtrl: NavController){

    }


    get$=createEffect(() =>this.actions$.pipe(
        ofType(CrudsActionType.GET),
        tap((data:any)=>{
            if(data.payload.type)
            {
                this.setType(data.payload.type)
                this.setTypeStatus("")
            }
            if(data.payload.query && data.payload.query.server)
            {
              this.setServer(data.payload.query.server)
            }
            else if(data.payload.typeStatus){
                this.setTypeStatus(data.payload.typeStatus)
            }
        }),
        mergeMap((data:any)=>this.crud.get(data.payload.path,data.payload.query).pipe(
            map((datas:any) => {
              return {type:this.typeStatus?this.typeStatus:this.type,payload:datas}
            }),
            tap(()=>{
                if(this.type=='[Table] Get' && this.initial)
                {
                    this.getCat()
                }else if(this.type=='[Categorie] Get' && this.initial){
                    this.getCard()
                }

            }),
            tap(()=>{if(this.type=='[auth] Login') this.navCtrl.navigateRoot('/')}),
            catchError((err) => of(new CrudFailedAction(err))),

        ))
    ))

    post$=createEffect(() =>this.actions$.pipe(
        ofType(CrudsActionType.POST),
        tap((data:any)=>{
            this.setTypeReload(data.payload.typeReload)
            this.setType(data.payload.type)
            this.saveDataPosted(data)
            this.loadingStatus(false,this.typeReload)}),
        mergeMap((data:any)=>this.crud.add(data.payload.path,JSON.stringify(data.payload.data)).pipe(
            tap((data:any)=>{this.loadingStatus(true,this.typeReload)}),
            map(data => ({type:this.type,payload:data})),
            tap(()=>{
                if(this.type=='[Card] upload' && this.initial)
                {
                    this.getProds()
                    this.initial=false
                }
            }),
            catchError((err) => of(new CrudFailedAction(err))),
        ))
    ))
    setServer(actionServer:number)
    {
      this.server=actionServer
    }
    setType(actionType:string)
    {
        this.type=actionType

    }
    setTypeStatus(actionType:string)
    {
        this.typeStatus=actionType

    }
    setTypeReload(typeReload:string)
    {
        this.typeReload=typeReload
    }
    saveDataPosted(data:any){
        this.data=Object.assign({},data)
        this.data=Object.assign({},this.data)
    }
    loadingStatus(resp:Boolean,type:string){
        this.store.dispatch({ type: loadDataActionType.LOAD,payload:{loaded:resp,typeReload:type} })
    }
    getCat(){
        this.store.dispatch({ type: CrudsActionType.GET,
          payload:{
                   type: '[Categorie] Get',
                   path:'/categories/marrakech/data.json'
                  }
        });
      }
    getProds()
      {
        this.store.dispatch({ type: CrudsActionType.POST,
          payload:{
                   type: '[ProdCommand] upload_procommand',
                   path:'/orders/data.json',
                  }
          });
      }
    getCard()
    {
        this.server ? (
          this.store.dispatch({ type: CrudsActionType.POST,
            payload:{
              type: '[Card] upload',
              path:'/orders/'+this.server+'/data.json',
            }
          })
        ):(
          this.store.dispatch({ type: CrudsActionType.POST,
            payload:{
              type: '[Card] upload',
              path:'/orders/data.json',
            }
          })
        )

    }

}
